import React from "react"
// import { Link } from "gatsby"
import {GatsbyImage, StaticImage} from 'gatsby-plugin-image'
// import { useLocation, navigate } from "@reach/router"
import Parser from 'html-react-parser'
import {sample} from 'lodash'

import { makeStyles, useTheme } from "@material-ui/core/styles"
// import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles"
import { alpha } from "@material-ui/core/styles/colorManipulator"
import Container from "@material-ui/core/Container"
// import Button from "@material-ui/core/Button"
import Grid from "@material-ui/core/Grid"
// import List from "@material-ui/core/List"
// import ListItem from "@material-ui/core/ListItem"
// import ListItemText from "@material-ui/core/ListItemText"
// import Divider from "@material-ui/core/Divider"
// import Paper from "@material-ui/core/Paper"
// import TextField from "@material-ui/core/TextField"
import Typography from "@material-ui/core/Typography"
import useMediaQuery from "@material-ui/core/useMediaQuery"
// import ArrowRight from "@material-ui/icons/ArrowForward"
import Header from "./ServicePageHeader"
import PhotoGalleryComponent from "./ServicePageGallery"
import ServicePageTestimonials from "./ServicePageTestimonials"
import Cta from "../CallToAction"
// import Faq from "../FaqSection"

const useStyles = makeStyles(theme => ({
  h1: {
    color: "#000",
    fontSize: "2.25rem",
    lineheight: "1.9rem",
    fontWeight: 600,
    textTransform: "uppercase",
  },
  h2: {
    fontFamily: "Lora, Work Sans, sans-serif",
    fontSize: "1.5rem",
    fontWeight: 400,
    color: theme.palette.secondary.light,
  },
  h3: {
    fontFamily: "Lora, Work Sans, sans-serif",
    fontSize: "1.5rem",
    fontWeight: 400,
    lineHeight: "1.4",
    color: theme.palette.common.muted,
    textTransform: "capitalize",
  },
  h5: {
    fontFamily: "Lora, Work Sans, sans-serif",
    fontSize: "1.05rem",
    color: "#fff",
    fontWeight: 600,
  },
  body: {
    // color: "#292929",
    fontSize: ".95rem",
    lineHeight: "1.7rem",
    [theme.breakpoints.only('xl')]: {
      paddingRight: '2rem',
    },
    [theme.breakpoints.only('md')]: {
      fontSize: '.9rem',
      paddingRight: '2rem'
    },
  },
  paper: {
    borderRadius: 0,
    border: `1px solid ${alpha(theme.palette.secondary.main, 0.6)}`,
    padding: "1rem",
  },
  cardTitle: {
    fontSize: "1.75rem",
    textTransform: "uppercase",
    color: theme.palette.secondary.main,
    fontWeight: 600,
    textDecoration: "none",
    transition: "0.5s",
    "&:hover": {
      color: "#000",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "1.45rem",
    },
  },
  contactBtn: {
    borderRadius: 0,
    fontSize: "1.1rem",
    padding: ".5rem 2rem",
    width: "100%",
    transition: "0.1s",
    "&:hover": {
      color: "#000",
      backgroundColor: theme.palette.primary.main,
      transform: "scale(1.1)",
    },
  },
  contactSection: {
    marginTop: "1rem",
    borderRadius: 0,
    border: `3px solid ${theme.palette.secondary.main}`,
    padding: "2rem 4rem",
    backgroundColor: "transparent",
    lineHeight: "1.5rem",
    [theme.breakpoints.down("xs")]: {
      padding: "2rem 2rem",
    },
  },
  contactSecText: {
    fontWeight: 500,
    fontSize: "1.1rem",
    color: theme.palette.common.muted,
  },
  promoOfferPaper: {
    borderRadius: 0,
    padding: ".5rem",
    backgroundColor: theme.palette.primary.light,
    [theme.breakpoints.down("xs")]: {
      marginLeft: "-1.5rem",
      marginRight: "-1.5rem",
    },
  },
  promoBorder: {
    padding: "2.5rem",
    border: `3px solid ${theme.palette.common.muted}`,
    borderStyle: "dashed",
  },
  promoHeader: {
    color: theme.palette.common.muted,
    fontWeight: 700,
    fontSize: "2.5rem",
    lineHeight: "3rem",
    marginBottom: "1rem",
  },
  promoSubHeader: {
    color: theme.palette.common.muted,
    fontWeight: 600,
    fontSize: "1.5rem",
  },
  promoSubtitle: {
    color: "rgba(0,0,0,0.8)",
    fontSize: ".9rem",
    marginTop: "-.5rem",
  },
  promoButton: {
    marginTop: "1rem",
    width: "100%",
    height: "3.125rem",
    color: "#FFFFFF",
    borderRadius: 0,
    backgroundColor: theme.palette.common.muted,
    "&:hover": {
      backgroundColor: "rgba(0,0,0,.9)",
    },
  },
  textField: {
    width: "100%",
    borderRadius: 0,
    backgroundColor: "#FFFFFF",
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    "& .MuiOutlinedInput-root": {
      borderRadius: 0,
      "&:hover": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "transparent",
        },
      },
    },
  },
  bottomBanner: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: 0,
    padding: "1rem",
    marginTop: "2rem",
    marginBottom: ".5rem",
    transition: "0.3s",
    "&:hover": {
      cursor: "pointer",
      transform: "scale(1.015)",
    },
  },
  ftImgCtr: {
    height: '100%',
    maxWidth: 336,
    borderRadius: 5,
    position: 'relative',
    '& img': {
      objectFit: 'cover',
      objectPosition: '50% 25%',
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: '2rem',
      maxWidth: 550
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: '2.5rem',
      maxWidth: 336,
    },
  },
  singleImage: {
    maxWidth: '70%',
    borderRadius: 5,
    maxHeight: '40rem',
    '& img': {
      objectFit: 'cover',
      objectPosition: '50% 25%',
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: 336,
    },
  }
}))


export default function ServicePage({ img, title, imageList, body, tagline, recreationalPonds = false, bogsSingleImage = false, }) {
  const theme = useTheme()
  const classes = useStyles()
  const matchesXS = useMediaQuery(theme.breakpoints.down("xs"))
  const matchesSM = useMediaQuery(theme.breakpoints.down("sm"))
  const matchesMD = useMediaQuery(theme.breakpoints.down("md"))
  const matchesXL = useMediaQuery(theme.breakpoints.up("xl"))
  // const location = useLocation()
  const pluralTitle = title + "s"
  const randomVar = sample([true, false])

  return (
    <>
      <Header img={img} title={pluralTitle} />

      <Grid
        container
        style={{
          paddingTop: matchesXS ? "3rem" : "5.5rem",
          paddingBottom: "6.5rem",
        }}
      >
        <Container
          maxWidth="lg"
          style={{ paddingBottom: matchesSM ? "3rem" : undefined }}
        >
          <Grid
            container
            direction={randomVar === true ? "row" : "row-reverse"}
          >
            <Grid item xs={12} md={7}>
              <Grid
                container
                style={{
                  marginLeft: matchesMD
                    ? undefined
                    : matchesXL
                    ? undefined
                    : "0.5rem",
                }}
              >
                <Grid item xs={12}>
                  {tagline && (
                    <Typography
                      variant="h2"
                      className={classes.h2}
                      gutterBottom
                    >
                      {tagline}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={12} style={{ marginTop: "1rem" }}>
                  {body &&
                    body.map(textBlock => {
                      if (textBlock.type === "paragraph") {
                        return (
                          <Typography
                            key={textBlock.id}
                            variant="body1"
                            className={classes.body}
                            paragraph
                          >
                            {Parser(textBlock.content)}
                          </Typography>
                        )
                      } else {
                        return (
                          <Typography
                            key={textBlock.id}
                            variant="h3"
                            className={classes.h3}
                            paragraph
                            gutterBottom
                          >
                            {textBlock.content}
                          </Typography>
                        )
                      }
                    })}
                </Grid>
              </Grid>
            </Grid>
            <Grid
              container
              item
              justifyContent={
                matchesMD
                  ? "center"
                  : randomVar === true
                  ? "flex-end"
                  : "center"
              }
              xs={12}
              md={5}
            >
              <GatsbyImage
                image={imageList[0].gatsbyImageData}
                alt={imageList[0].title}
                className={classes.ftImgCtr}
              />
              {/* <GatsbyImage
                        style={{ position: "initial" }}
                        image={img.gatsbyImageData}
                        alt={img.title}
                      /> */}
            </Grid>
          </Grid>
        </Container>
      </Grid>
      {recreationalPonds && (
        <Container maxWidth="lg" style={{ paddingBottom: "3rem" }}>
          <Grid container>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={12} container>
                  <Grid item xs={12} style={{ paddingBottom: "1rem" }}>
                    <Typography
                      variant="h2"
                      className={classes.h2}
                      gutterBottom
                    >
                      History of Natural Swimming Ponds in the Rogue Valley
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} md={2} container justifyContent='center' style={{marginBottom: matchesXS ? '1.5rem' : undefined}}>
                    <StaticImage
                      src="../../assets/images/IOB_logo.jpg"
                      quality={90}
                      objectFit='contain'
                      alt="International Organization for Natural Bathing Waters (IOB)"
                    />
                  </Grid>
                  <Grid item xs={12} md={10} sm={8}>
                    <Typography
                      variant="body1"
                      className={classes.body}
                      paragraph
                    >
                      We are members of the International Organization for
                      Natural Bathing Waters (IOB) and have had the opportunity
                      to learn and consult with the leading natural swimming
                      pool builders in the world. Having had the privilege of
                      attending multiple international IOB conferences has given
                      us a unique opportunity to expand our understanding of why
                      these beautiful swimming ponds have been enhancing both
                      residential and commercial landscapes all over Europe for
                      many years.
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      variant="body1"
                      className={classes.body}
                      paragraph
                    >
                      We began building recreational ponds in the Rogue Valley
                      in 2016. Our swim pond design has evolved over the years,
                      and we are proud to be able to say that we are the leading
                      NSP contractors in the state of Oregon. We’ve brought
                      together the knowledge gained from our global network of
                      natural swimming pool builders with the unique style that
                      Andreatta Waterscapes is known for, to create what has
                      commonly become known here in the United States as
                      recreational ponds.
                    </Typography>
                    <Typography
                      variant="body1"
                      className={classes.body}
                      paragraph
                    >
                      Call us to set up a design consultation and we’ll help you
                      create the backyard swim pond of your dreams!
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      )}
     {imageList && bogsSingleImage ? (

     <Grid container justifyContent='center'>
       <GatsbyImage
       image={imageList[1].gatsbyImageData}
       alt={imageList[1].title}
       className={classes.singleImage} />
     </Grid>
     
     ) : (<PhotoGalleryComponent title={title} imageList={imageList} />)}
      {/* {imageList && (
        <PhotoGalleryComponent title={title} imageList={imageList} />
      )} */}
      <ServicePageTestimonials />
      <Cta end={true} />
    </>
  )
}
